module.exports = __webpack_public_path__ + "img/circle_num_3_green.e1d38640.svg";